import {fetch} from "utils/dataAccess";

export async function getToBeEnriched(retailerId, page, itemsPerPage) {
    const response = await fetch(`/products/to-enrich?retailer_id=${retailerId}&page=${page}&itemsPerPage=${itemsPerPage}`);

    return await response.json();
}
